export const getKeyFromString = (partialKey) => {
  const keys = Object.keys(window.localStorage);
  const key = keys.find(item => item.indexOf(partialKey) !== -1);

  return key;
}

export const getValueFromPartialKey = (partialKey) => {
  const keys = Object.keys(window.localStorage);
  const key = keys.find(item => item.indexOf(partialKey) !== -1);

  if (key) {
    return window.localStorage.getItem(key);
  }

  return null;
}

export const setValue = (key, value) => {
  window.localStorage.setItem(key, value);
}



// WEBPACK FOOTER //
// ./src/utils/localStorageManager.js